import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  children
}: ModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div ref={overlayRef} className="fixed inset-0 z-50 flex items-start justify-center pt-[10vh] px-4" onClick={e => {
    if (e.target === overlayRef.current) onClose();
  }} data-id="element-1602">
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" data-id="element-1603" />
      <div className="relative bg-white rounded-2xl shadow-2xl border border-slate-200 w-full max-w-2xl max-h-[80vh] overflow-y-auto" data-id="element-1604">
        <div className="sticky top-0 bg-white border-b border-slate-100 px-6 py-4 flex items-center justify-between rounded-t-2xl z-10" data-id="element-1605">
          <div data-id="element-1606">
            <h3 className="text-[15px] font-semibold text-slate-900" data-id="element-1607">
              {title}
            </h3>
            {subtitle && <p className="text-[13px] text-slate-500 mt-0.5" data-id="element-1608">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors p-1 rounded-lg hover:bg-slate-100" data-id="element-1609">
            <X className="w-5 h-5" data-id="element-1610" />
          </button>
        </div>
        <div className="p-6" data-id="element-1611">{children}</div>
      </div>
    </div>;
}